import { IonGrid, IonText } from "@ionic/react";
import "./moduleHeader.css";
import { SingleModuleHeader } from "./SingleModuleHeader";

interface IModuleHeader {
  module: any;
  examInfo: any;
  handleTestExam: () => void;
}
export const ModuleHeader: React.FC<IModuleHeader> = ({
  module,
  examInfo,
  handleTestExam,
}) => {
  return (
    <IonGrid className="ion-grid-title-container-black-module">
      <SingleModuleHeader
        module={module}
        index={0}
        examInfo={examInfo}
        handleTestExam={handleTestExam}
      />
      <IonText style={{ color: "#E6E6E7" }}>
        {" "}
        Recuerda reveer y practicar cada técnica para incorporar mejor el
        aprendizaje.{" "}
      </IonText>
    </IonGrid>
  );
};
